import CustomerInteractionClient from "@common/api/CustomerInteractionClient";
import InteractionOptionsAction from "@common/redux/actions/InteractionOptionsAction";
import { handleError } from "@common/components/helpers/error";

export const fetchInteractionOptions = () => {
  InteractionOptionsAction.setLoadingOptions(true).then(() =>
    CustomerInteractionClient.MetaData()
      .then((response) => {
        InteractionOptionsAction.dispatch({
          customerInteractionOptions: response,
        });
      })
      .catch((error) => {
        console.error(error);
        handleError(error);
      })
      .finally(() => {
        InteractionOptionsAction.setLoadingOptions(false);
      }),
  );
};
